if(document.getElementById('app_pro_listproduct') != null){

    document.addEventListener('alpine:init', () => {

        Alpine.data('app_pro_listproduct', (route, userCdfs) =>({
            listProduct : [],
            voirPlusProduct : false,
            listSubs : [],
            listCDFs : [],
            voirPlusSubs : false,
            is_loaded : false,
            showLoader : true,
            init(){
                this.route = route;
                this.userCdfs = userCdfs;
                this.loadProducts();

            },

            loadProducts(){
                this.listProduct = [];
                axios({
                    method: 'get',
                    url: route
                }).then(response =>{

                    for (let i = 0; i < response.data.products.length; i++) {
                        if(i>2){
                            response.data.products[i]['UI_HIDDEN_IN_VOIR_PLUS'] = true;
                        }else{
                            response.data.products[i]['UI_HIDDEN_IN_VOIR_PLUS'] = false;
                        }

                        //les products.avantages new 27-02-2024
                        response.data.products[i]['avantages_tab']=[];
                        if(response.data.products[i].avantages){
                            response.data.products[i]['avantages_tab'] =  response.data.products[i].avantages.split(/(?:\r\n|\r|\n)/g);
                            for (let idesc = 0; idesc <  response.data.products[i]['avantages_tab'].length; idesc++) {
                                if( response.data.products[i]['avantages_tab'][idesc]  == ""){
                                    response.data.products[i]['avantages_tab'][idesc] = false;
                                }
                            }
                        }
                    }

                    for (let i = 0; i < response.data.subs.length; i++) {
                        if(i>2){
                            response.data.subs[i]['UI_HIDDEN_IN_VOIR_PLUS'] = true;
                        }else{
                            response.data.subs[i]['UI_HIDDEN_IN_VOIR_PLUS'] = false;
                        }

                        //les products.avantages new 27-02-2024
                        response.data.subs[i]['avantages_tab']=[];
                        if(response.data.subs[i].avantages){
                            response.data.subs[i]['avantages_tab'] =  response.data.subs[i].avantages.split(/(?:\r\n|\r|\n)/g);
                            for (let idesc = 0; idesc <  response.data.subs[i]['avantages_tab'].length; idesc++) {
                                if( response.data.subs[i]['avantages_tab'][idesc]  == ""){
                                     response.data.subs[i]['avantages_tab'][idesc] = false;
                                }
                            }
                        }

                    }

                    for (let i = 0; i < response.data.cdfs.length; i++) {

                        if(i>3){
                           response.data.cdfs[i]['UI_HIDDEN_IN_VOIR_PLUS'] = true;
                        }else{
                           response.data.cdfs[i]['UI_HIDDEN_IN_VOIR_PLUS'] = false;
                        }

                        response.data.cdfs[i]['UI_IS_OWNED'] = false;
                        response.data.cdfs[i]['userCdf'] = null;
                        for (let j = 0; j < this.userCdfs.length; j++) {
                            if( response.data.cdfs[i].id == this.userCdfs[j].cdf_id){
                                response.data.cdfs[i]['UI_IS_OWNED'] = true;
                                response.data.cdfs[i]['userCdf'] = this.userCdfs[j];
                            }
                        }
                   }

                   if( response.data.cdfs < 3){
                       this.voirPlusCDFS = true;
                   }

                    if( response.data.subs.length < 3){
                        this.voirPlusSubs = true;
                    }

                    if( response.data.products.length < 3){
                        this.voirPlusProduct = true;
                    }


                    this.$nextTick(() => {
                        this.listProduct = response.data.products;
                        this.listSubs = response.data.subs;
                        this.listCDFs = response.data.cdfs;
                        console.log(this.listProduct);
                    });
                    this.showLoader = false;
                    this.is_loaded = true;

                });
            }
        }))
    })

}
